import styled from 'styled-components';

export const CourseItemWrapper = styled.div`
  border-radius: 5px;
`;
